var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "carteira container-fluid" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "d-flex justify-center align-center pa-4" },
          [
            _c("v-progress-circular", {
              attrs: { size: 35, color: "primary", indeterminate: "" }
            })
          ],
          1
        )
      : _c("div", [
          _c("div", { staticClass: "cards" }, [
            _c("div", { staticClass: "card" }, [
              _c("span", { staticClass: "title" }, [_vm._v("Saldo Bruto")]),
              _c("span", { staticClass: "valor" }, [
                _vm._v(
                  _vm._s(_vm.currencyHelper.formatValue(_vm.evolucaoSaldo))
                )
              ])
            ]),
            _c("div", { staticClass: "card" }, [
              _c("span", { staticClass: "title" }, [_vm._v("Saldo Liquido")]),
              _c("span", { staticClass: "valor" }, [
                _vm._v(
                  _vm._s(_vm.currencyHelper.formatValue(_vm.evolucaoLiquido))
                )
              ])
            ]),
            _c("div", { staticClass: "card" }, [
              _c("span", { staticClass: "title" }, [_vm._v("Rendimento")]),
              _c("span", { staticClass: "valor" }, [
                _vm._v(
                  _vm._s(_vm.currencyHelper.formatValue(_vm.evolucaoRendimento))
                )
              ])
            ]),
            _c("div", { staticClass: "card" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v("Rendimento Histórico")
              ]),
              _c("span", { staticClass: "valor" }, [
                _vm._v(
                  _vm._s(
                    _vm.percentageHelper.formatPercentage(_vm.evolucaoGanho)
                  )
                )
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "search-bar" },
            [
              _c("v-text-field", {
                staticClass: "text-field",
                attrs: {
                  placeholder: "Pesquisar",
                  outlined: "",
                  rounded: "",
                  dense: "",
                  "background-color": "white",
                  "prepend-inner-icon": "mdi-magnify"
                },
                model: {
                  value: _vm.searchAtivo,
                  callback: function($$v) {
                    _vm.searchAtivo = $$v
                  },
                  expression: "searchAtivo"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "acorddions" },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { sm: "12", md: "6", xs: "12" } },
                    [
                      _c(
                        "v-expansion-panels",
                        {
                          model: {
                            value: _vm.panel,
                            callback: function($$v) {
                              _vm.panel = $$v
                            },
                            expression: "panel"
                          }
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "header-prefixo panel" },
                                [
                                  _c("div", { staticClass: "teste" }, [
                                    _c("div", { staticClass: "titles" }, [
                                      _c("span", [_vm._v("Juros Pré(fixo)")])
                                    ]),
                                    _c("div", { staticClass: "valor" }, [
                                      _c("span", { staticClass: "saldo" }, [
                                        _vm._v("Saldo bruto ")
                                      ]),
                                      _c("span", { staticClass: "value" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currencyHelper.formatValue(
                                              _vm.saldoJurosPre
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ])
                                ]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { attrs: { id: "content-expansion" } },
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-1 table",
                                    attrs: {
                                      height: "40vh",
                                      search: _vm.searchAtivo,
                                      headers: _vm.headers,
                                      "no-data-text": "Não encontrado",
                                      items: _vm.dessertsJurosPre.items,
                                      "items-per-page": 100000,
                                      "hide-default-footer": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item.value",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currencyHelper.formatValue(
                                                      item.value
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.fat",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "slot-btns" },
                                                [
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/graph_bar_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showMovimentacao(
                                                          "editarUsuario",
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/add_circle_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showModal(
                                                          "editarUsuario",
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/remove_circle_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deletItem(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "top",
                                          fn: function() {
                                            return [
                                              _c(
                                                "v-dialog",
                                                {
                                                  attrs: {
                                                    "max-width": "500px"
                                                  },
                                                  model: {
                                                    value: _vm.dialogDelete,
                                                    callback: function($$v) {
                                                      _vm.dialogDelete = $$v
                                                    },
                                                    expression: "dialogDelete"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-card",
                                                    {
                                                      staticClass: "card-dialog"
                                                    },
                                                    [
                                                      _c(
                                                        "v-card-title",
                                                        {
                                                          staticClass: "text-h5"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "Vender ativo?"
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-card-text",
                                                        {
                                                          staticClass:
                                                            "descricao-dialog"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Isso irá apagar permanentemente todas as informações e transações anteriormente cadastradas "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-card-actions",
                                                        [
                                                          _c("v-spacer"),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "btn-cancel-dialog",
                                                              attrs: {
                                                                color:
                                                                  "blue darken-1",
                                                                text: ""
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.closeDelete
                                                              }
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "Cancelar"
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "btn-delete-dialog",
                                                              attrs: {
                                                                color:
                                                                  "blue darken-1",
                                                                text: ""
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.deletarAtivo
                                                              }
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v("Vender")
                                                              ])
                                                            ]
                                                          ),
                                                          _c("v-spacer")
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "btn-close-dialog",
                                                          on: {
                                                            click:
                                                              _vm.closeDialog
                                                          }
                                                        },
                                                        [
                                                          _c("v-img", {
                                                            attrs: {
                                                              src: require("@/assets/icons/clear_icon.svg")
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "header-posinflacao panel" },
                                [
                                  _c("div", { staticClass: "teste" }, [
                                    _c("div", { staticClass: "titles" }, [
                                      _c("span", [
                                        _vm._v("Juros Pós(Inflação)")
                                      ])
                                    ]),
                                    _c("div", { staticClass: "valor" }, [
                                      _c("span", { staticClass: "saldo" }, [
                                        _vm._v("Saldo bruto ")
                                      ]),
                                      _c("span", { staticClass: "value" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currencyHelper.formatValue(
                                              _vm.saldoJurosPosInflacao
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ])
                                ]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { attrs: { id: "content-expansion" } },
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-1 table",
                                    attrs: {
                                      search: _vm.searchAtivo,
                                      height: "40vh",
                                      headers: _vm.headers,
                                      "no-data-text": "Não encontrado",
                                      items: _vm.dessertsJurosPosInflacao.items,
                                      "items-per-page": 100000,
                                      "hide-default-footer": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item.value",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currencyHelper.formatValue(
                                                      item.value
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.fat",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "slot-btns" },
                                                [
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/graph_bar_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showMovimentacao(
                                                          "editarUsuario",
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/add_circle_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showModal(
                                                          "editarUsuario",
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/remove_circle_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deletItem(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "header-cambio panel" },
                                [
                                  _c("div", { staticClass: "teste" }, [
                                    _c("div", { staticClass: "titles" }, [
                                      _c("span", [_vm._v("Câmbio")])
                                    ]),
                                    _c("div", { staticClass: "valor" }, [
                                      _c("span", { staticClass: "saldo" }, [
                                        _vm._v("Saldo bruto ")
                                      ]),
                                      _c("span", { staticClass: "value" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currencyHelper.formatValue(
                                              _vm.saldoCambio
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ])
                                ]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { attrs: { id: "content-expansion" } },
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-1 table",
                                    attrs: {
                                      search: _vm.searchAtivo,
                                      height: "40vh",
                                      headers: _vm.headers,
                                      "no-data-text": "Não encontrado",
                                      items: _vm.dessertsCambio.items,
                                      "items-per-page": 100000,
                                      "hide-default-footer": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item.value",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currencyHelper.formatValue(
                                                      item.value
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.fat",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "slot-btns" },
                                                [
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/graph_bar_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showMovimentacao(
                                                          "editarUsuario",
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/add_circle_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showModal(
                                                          "editarUsuario",
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/remove_circle_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deletItem(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { sm: "12", md: "6", xs: "12" } },
                    [
                      _c(
                        "v-expansion-panels",
                        {
                          model: {
                            value: _vm.panel2,
                            callback: function($$v) {
                              _vm.panel2 = $$v
                            },
                            expression: "panel2"
                          }
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "header-precdi panel" },
                                [
                                  _c("div", { staticClass: "teste" }, [
                                    _c("div", { staticClass: "titles" }, [
                                      _c("span", [_vm._v("Juros Pós(CDI)")])
                                    ]),
                                    _c("div", { staticClass: "valor" }, [
                                      _c("span", { staticClass: "saldo" }, [
                                        _vm._v("Saldo bruto ")
                                      ]),
                                      _c("span", { staticClass: "value" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currencyHelper.formatValue(
                                              _vm.saldoJurosPosCdi
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ])
                                ]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { attrs: { id: "content-expansion" } },
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-1 table",
                                    attrs: {
                                      search: _vm.searchAtivo,
                                      height: "40vh",
                                      headers: _vm.headers,
                                      "no-data-text": "Não encontrado",
                                      items: _vm.dessertsJurosPosCdi.items,
                                      "items-per-page": 100000,
                                      "hide-default-footer": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item.value",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currencyHelper.formatValue(
                                                      item.value
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.fat",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "slot-btns" },
                                                [
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/graph_bar_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showMovimentacao(
                                                          "editarUsuario",
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/add_circle_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showModal(
                                                          "editarUsuario",
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/remove_circle_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deletItem(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "header-rendavariavel panel" },
                                [
                                  _c("div", { staticClass: "teste" }, [
                                    _c("div", { staticClass: "titles" }, [
                                      _c("span", [_vm._v("Renda variável")])
                                    ]),
                                    _c("div", { staticClass: "valor" }, [
                                      _c("span", { staticClass: "saldo" }, [
                                        _vm._v("Saldo bruto ")
                                      ]),
                                      _c("span", { staticClass: "value" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currencyHelper.formatValue(
                                              _vm.saldoRendaVariavel
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ])
                                ]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { attrs: { id: "content-expansion" } },
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-1 table",
                                    attrs: {
                                      search: _vm.searchAtivo,
                                      height: "40vh",
                                      headers: _vm.headers,
                                      "no-data-text": "Não encontrado",
                                      items: _vm.dessertsRendaVariavel.items,
                                      "items-per-page": 100000,
                                      "hide-default-footer": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item.value",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currencyHelper.formatValue(
                                                      item.value
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.fat",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "slot-btns" },
                                                [
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/graph_bar_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showMovimentacao(
                                                          "editarUsuario",
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/add_circle_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showModal(
                                                          "editarUsuario",
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/remove_circle_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deletItem(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "header-livres panel" },
                                [
                                  _c("div", { staticClass: "teste" }, [
                                    _c("div", { staticClass: "titles" }, [
                                      _c("span", [_vm._v("Livres")])
                                    ]),
                                    _c("div", { staticClass: "valor" }, [
                                      _c("span", { staticClass: "saldo" }, [
                                        _vm._v("Saldo bruto ")
                                      ]),
                                      _c("span", { staticClass: "value" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currencyHelper.formatValue(
                                              _vm.saldoLivre
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ])
                                ]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { attrs: { id: "content-expansion" } },
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-1 table",
                                    attrs: {
                                      search: _vm.searchAtivo,
                                      height: "40vh",
                                      headers: _vm.headers,
                                      "no-data-text": "Não encontrado",
                                      items: _vm.dessertsLivre.items,
                                      "items-per-page": 100000,
                                      "hide-default-footer": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "item.value",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currencyHelper.formatValue(
                                                      item.value
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.fat",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "slot-btns" },
                                                [
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/graph_bar_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showMovimentacao(
                                                          "editarUsuario",
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/add_circle_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showModal(
                                                          "editarUsuario",
                                                          $event,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("v-img", {
                                                    staticClass: "btn-icon",
                                                    attrs: {
                                                      src: require("@/assets/icons/remove_circle_icon.svg")
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deletItem(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }